import WelcomePage from "../../components/WelcomeComponents";

const LPWelcome = () => {
  return <WelcomePage />;
};
export default LPWelcome;
